export const splitTitle = (data) => {
  if (data) {
    const title = data.split(' ')
    if (title.length > 1) {
      const [blueTitle, ...others] = title
      return {
        blueTitle,
        title: others.join(' '),
      }
    }
    return title
  }
  return ''
}

export function getTechnologyData(tech) {}

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
// moment.utc treats ISO strings without an offset as UTC; `new Date` treats them as local
const ISO_NO_OFFSET =
  /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?))?$/

// Same output as moment's `format('MMMM DD, YYYY')` (e.g. "October 05, 2026"),
// including "Invalid date". Default matches `moment(new Date(date))`;
// `utc: true` matches `moment.utc(date)`.
export function formatDate(
  date?: string | number | Date | null,
  { utc = false }: { utc?: boolean } = {}
) {
  let d: Date
  if (!utc) d = new Date(date as string)
  else if (date === undefined) d = new Date()
  else if (date === null || date === '') d = new Date(NaN)
  else if (typeof date === 'string' && ISO_NO_OFFSET.test(date.trim())) {
    const [, day, time] = date.trim().match(ISO_NO_OFFSET) as RegExpMatchArray
    d = new Date(time ? `${day}T${time}Z` : day)
  } else if (typeof date === 'string') {
    // moment.utc's fallback for other strings is `new Date(date + ' UTC')`
    const asUtc = new Date(`${date} UTC`)
    d = isNaN(asUtc.getTime()) ? new Date(date) : asUtc
  } else d = new Date(date)

  if (isNaN(d.getTime())) return 'Invalid date'
  const year = utc ? d.getUTCFullYear() : d.getFullYear()
  const month = utc ? d.getUTCMonth() : d.getMonth()
  const day = utc ? d.getUTCDate() : d.getDate()
  const yyyy =
    year < 0
      ? `-${String(-year).padStart(6, '0')}`
      : String(year).padStart(4, '0')
  return `${MONTHS[month]} ${String(day).padStart(2, '0')}, ${yyyy}`
}
